import { Plugin } from '@nuxt/types';
import accessTokenManagerInstance from '~/api/v4/access-token-manager-instance';

const AccessTokenManagerPlugin: Plugin = (context, inject) => {
  accessTokenManagerInstance.storage.setStore(context.store);
  inject('accessToken', accessTokenManagerInstance);
};

export default AccessTokenManagerPlugin;
